import ArtifactGroupType from "../base/ArtifactGroupType";

const NebraDisc = {
  id: '104',
  name: 'Nebra Disc',
  icon: 'NebraDisc',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 50,
  gameId: 'NebraDisc'
};

export default NebraDisc;
